"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
define('evisions/evimenu/evimenu',['jquery', 'underscore', 'vertebrae'], function ($, _, Vertebrae) {
  var EVIMenu = {};
  var _repositionFn = null,
    _closeFn = null,
    calculationDropDownPosition = null,
    _ddLastElement = null,
    renderMenuFrame = 'evimenu.init',
    renderMenuItem = 'evimenu.default.item';
  calculationDropDownPosition = function calculationDropDownPosition(el, options) {
    options.vertical = options.vertical || 'bottom';
    options.horizontal = options.horizontal || 'left';
    options.offset = options.offset || {
      top: 0,
      left: 0
    };
    var ddWidth = el.width(),
      btHeight = options.element.height(),
      docHeight = $(document).height();
    el.find("ul").css("max-height", docHeight / 2 - 2 * btHeight - (btOffLeft || 0));
    var ddHeight = el.height(),
      btWidth = options.element.width(),
      btOffLeft = options.element.offset().left,
      btOffTop = options.element.offset().top,
      finalOffsets = {
        top: 0,
        left: 0
      },
      vertCaret = "",
      calculateVert = null,
      calculateHoriz = null,
      horizCaret = "";
    calculateVert = function calculateVert(pos) {
      if (pos === 'top') {
        vertCaret = "bottom";
        finalOffsets.top = btOffTop - ddHeight - btHeight;
      } else {
        vertCaret = "top";
        finalOffsets.top = btOffTop + btHeight;
      }
    };
    calculateHoriz = function calculateHoriz(pos) {
      if (pos === 'left') {
        horizCaret = "right";
        finalOffsets.left = btOffLeft - ddWidth + btWidth;
      } else {
        horizCaret = "left";
        finalOffsets.left = btOffLeft;
      }
    };
    calculateVert(options.vertical);
    calculateHoriz(options.horizontal);
    if (!options.forcePositioning) {
      if (options.vertical === 'bottom') {
        if (docHeight < finalOffsets.top + ddHeight) {
          calculateVert('top');
        }
      } else {
        if (0 > finalOffsets.top) {
          calculateVert('bottom');
        }
      }
      if (options.horizontal === 'right') {
        if ($(document).width() < finalOffsets.left + ddWidth) {
          calculateHoriz('left');
        }
      } else {
        if (0 > finalOffsets.left) {
          calculateHoriz('right');
        }
      }
    }
    finalOffsets.left += options.offset.left || 0;
    finalOffsets.top += options.offset.top || 0;
    el.css(finalOffsets);
    el.removeClass('top-left').removeClass('top-right').removeClass('bottom-right').removeClass('bottom-left');
    if (!options.caret) {
      el.addClass(vertCaret + '-' + horizCaret);
    }
  };
  EVIMenu.reposition = function () {
    if (_repositionFn) {
      _repositionFn();
    }
  };
  EVIMenu.show = function (options, items) {
    var dd = null,
      d = Promise.defer(),
      body = $(document.body),
      name = null,
      item = null,
      ritems = [],
      sameElement = _ddLastElement == options.element.get(0);
    if (options.ignoreIfSameElementShown && sameElement) {
      return Promise.reject().ignore();
    }
    if (_closeFn) {
      EVIMenu.hide();
      if (sameElement) {
        return Promise.reject().ignore();
      }
    }
    _ddLastElement = options.element ? options.element.get(0) : null;
    for (var i = 0; i < items.length; ++i) {
      item = items[i];
      if (!_.isObject(item)) {
        item = {
          text: item
        };
      }
      item.i = i;
      ritems.push(Vertebrae.View.template(options.template || renderMenuItem, item));
    }
    dd = Vertebrae.View.template(renderMenuFrame, {
      'class': options.className,
      'items': ritems
    });
    var el = $(dd);
    el.find("ul").attr("role", "menu");
    el.find("ul li input.hidden-file-upload").attr("tabindex", "-1");
    el.find("ul li").each(function (index, item) {
      $(item).attr("role", "menuitem");
    });
    if (options.container) {
      options.container.append(el);
    } else {
      body.append(el);
    }
    if (options.element && !options.container) {
      calculationDropDownPosition(el, options || {});
    } else if (options.offset) {
      var offset = options.offset;
      if (_typeof(options.offset.top) !== undefined) {
        el.css({
          top: options.offset.top
        });
      }
      if (_typeof(options.offset.left) !== undefined) {
        el.css({
          left: options.offset.left
        });
      }
      if (_typeof(options.offset.right) !== undefined) {
        el.css({
          right: options.offset.right
        });
      }
    }
    if (options.caret) {
      el.addClass(options.caret);
    }
    _closeFn = function _closeFn() {
      if (d.promise.isFulfilled() || d.promise.isRejected()) {
        d.reject();
      }
      _ddLastElement = null;
      el.off('click');
      el.remove();
    };
    _repositionFn = function _repositionFn() {
      if (options.parent && options.element) {
        if (options.element.offset().top < options.parent.offset().top) {
          return EVIMenu.hide();
        }
      }
      calculationDropDownPosition(el, options || {});
    };
    _.defer(function () {
      body.one('click.evimenu', function (ev) {
        ev.stopPropagation();
        EVIMenu.hide();
      });
    });
    $('div[title="Add a document"]').on('keydown', function (ev) {
      if (ev.key === "ArrowDown") {
        el.find("ul li")[0].focus();
      }
    });
    el.one('click', 'li', function (ev) {
      if (options.noHide) {
        ev.stopPropagation();
      }
      if (ev.originalEvent) {
        ev.originalEvent.DropDownMenuClick = true;
        var canResolve = false,
          index = null;
        try {
          index = Number(ev.currentTarget.attributes['data-index'].value);
          if (!_.isNaN(index)) {
            canResolve = true;
          }
        } catch (e) {}
        if (canResolve) {
          return d.resolve({
            index: index
          });
        } else {
          return d.reject(-1);
        }
      }
    });
    el.on('keydown', 'li', function (ev) {
      var canResolve = false;
      var index = Number(ev.currentTarget.attributes['data-index'].value);
      var itemsLength = el.find("ul li").length;
      if (ev.key === 'Escape') {
        ev.preventDefault();
        ev.stopPropagation();
        EVIMenu.hide();
        $('div[title="Add a document"]').focus();
        return;
      }
      if (ev.key === "ArrowDown") {
        ev.stopPropagation();
        try {
          if (!_.isNaN(index)) {
            if (index === itemsLength - 1) {
              el.find("ul li")[0].focus();
            } else {
              el.find("ul li")[index + 1].focus();
            }
          }
        } catch (e) {}
        return;
      }
      if (ev.key === "ArrowUp") {
        ev.stopPropagation();
        try {
          if (!_.isNaN(index)) {
            if (index === 0) {
              el.find("ul li")[itemsLength - 1].focus();
            } else {
              el.find("ul li")[index - 1].focus();
            }
          }
        } catch (e) {}
        return;
      }
      if (!["Enter", " "].includes(ev.key)) {
        return;
      }
      ev.originalEvent.DropDownMenuClick = true;
      if (["Enter", " "].includes(ev.key)) {
        try {
          if (!_.isNaN(index)) {
            canResolve = true;
          }
        } catch (e) {}
        if (canResolve) {
          return d.resolve({
            index: index,
            item: el
          });
        } else {
          return d.reject(-1);
        }
      }
    });
    el.css('display', 'inline-block');
    el.find("ul li")[0].focus();
    return d.promise;
  };
  EVIMenu.hide = function () {
    if (_closeFn) {
      $("body").unbind("click.evimenu");
      _closeFn();
      _closeFn = null;
      _repositionFn = null;
    }
  };
  Vertebrae.Event.on('window-keypress', function (ev, keyCode) {
    if (keyCode == 27) {
      EVIMenu.hide();
    }
  });
  return EVIMenu;
});

